// src/routes/PublicOnlyRoute.tsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useHydratedAccess } from "../hooks/useHydratedAccess";
import { useAccessStore } from "../lib/store/useAccessStore";

export default function PublicOnlyRoute() {
  const hydrated = useHydratedAccess();
  const isAuthed = useAccessStore((s) => s.isAuthenticated());
  const loc = useLocation();

  if (!hydrated) return null;

  if (isAuthed) {
    // 이미 로그인 → 돌아가거나 홈으로
    const state = loc.state as { from?: { pathname?: string } } | null;
    const to = state?.from?.pathname ?? "/";
    return <Navigate to={to} replace />;
  }
  return <Outlet />;
}